/**
 * Product Tour del Studio, inmersivo: pantalla completa real (la ruta vive FUERA del
 * DashboardLayout, como el Clapper Arcade). "Salir del tour" está en el recorrido y llega
 * como `st:exit` por el puente.
 */
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { WinclapLoader } from '@/components/ui/winclap-loader';
import { useStudioTourBridge } from './useStudioTourBridge';

export function StudioTourPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { isLoading, error } = useStudioTourBridge(iframeRef, () => navigate('/studio'));

  return (
    <div className="fixed inset-0 z-50 bg-background">
      {error ? (
        <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="text-sm font-medium text-destructive">{t('studio.tour.load_error', 'No se pudo cargar el Product Tour')}</p>
          <p className="max-w-md text-xs text-muted-foreground">{error.message}</p>
          <button
            onClick={() => navigate('/studio')}
            className="inline-flex items-center gap-1.5 rounded-md border px-4 py-2 text-sm hover:bg-accent"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('studio.tour.back', 'Volver al Studio')}
          </button>
        </div>
      ) : isLoading ? (
        <div className="flex h-full flex-col items-center justify-center gap-4">
          <WinclapLoader size={48} className="text-foreground/25" />
          <span className="text-xs tracking-widest text-muted-foreground">{t('studio.tour.loading', 'Preparando tu recorrido…')}</span>
        </div>
      ) : (
        <iframe
          ref={iframeRef}
          src="/studio-tour/index.html"
          title={t('studio.tour.title', 'Product Tour · Winclap Studio')}
          className="h-full w-full border-0"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        />
      )}
    </div>
  );
}
